<template>
  <div id="root">
    <Header />
    <div class="main d-flex">
      <notifications
        group="ConfigTool"
        classes="config-notification"
        style="width: 300px; top: 20px; right: 5px; color: rgba(122, 184, 0, 1)"
      />
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './components/UIComponents/Header'
import Footer from './components/UIComponents/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
</style>

<style lang="scss">
  .config-notification {
    font-size: 14px;
    padding-top: 10px;
    padding-left: 20px;
    padding-bottom: 10px;
    color: rgba(122, 184, 0, 1);
    background: white;
    border-top: 2px solid rgb(94, 164, 0);

    &.warn {
      background: #ffb648;
      color: rgb(236, 61, 61);
      border-top: 2px solid rgb(94, 164, 0);
    }

    &.error {
      background: #FFE4E1;
      color: rgb(236, 61, 61);
      border-top: 2px solid rgb(236, 61, 61);
    }
  }

  .notification-content {
    color: #000000;
    font-size: 13px;
  }
</style>
